//@ts-nocheck
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { validateAccessGranted } from '../../utils/accessGrantedValidator';

const ReportItem = ({ route, label }: { route: string; label: string }) => {
  const navigate = useNavigate();
  return (
    <div style={{ paddingLeft: 72, marginTop: 10, position: 'relative' }}>
      <div
        style={{ display: 'inline-flex', cursor: 'pointer' }}
        onClick={() => {
          navigate(route);
        }}
      >
        <div>
          <span className="nucleus-tools-page-text-title">{label}</span>
        </div>
        <div>
          <span className="nucleus-table-icon nucleus-link">
            <i className="Tiny material-icons">chevron_right</i>
          </span>
        </div>
      </div>
    </div>
  );
};

const Reports = () => {
  useEffect(() => {
    validateAccessGranted('/reports');
  }, []);

  return (
    <div className="nucleus-hard-container">
      <div className="nucleus-all-scrollable-page">
        <p className="nucleus-page-title">Reports</p>
        <div>
          <span className="nucleus-tools-page-text-title" style={{ fontSize: 18 }}>
            Reports by
          </span>
        </div>
        <ReportItem route="/reports/calls" label="Calls" />
        <ReportItem route="/reports/patient-notes" label="Patient Notes" />
      </div>
    </div>
  );
};

export default Reports;
